export const pt = {
    title: `Criar conta`,
    description: `Junte-se a nós hoje`,
    success: `Conta criada com sucesso!`,
    successInstructions: `Por favor verifique seu e-mail para confirmação.`,
    alreadyHaveAccount: `Já tem uma conta?`,
    failure: `Falha no registro. Por favor tente novamente.`,
};
//# sourceMappingURL=pt.js.map